export const TypeGuardService = {
	isFieldsBlock(content: FieldsContent['content']): content is FieldsBlock {
		return content.contentType === 'FieldsBlock';
	},

	isSummaryProductDetailsBlock(content: FieldsContent['content']): content is SummaryProductDetailsBlock {
		return content.contentType === 'SummaryProductDetailsBlock';
	},

	isSummaryTotalPriceDetailsBlock(content: FieldsContent['content']): content is SummaryTotalPriceDetailsBlock {
		return content.contentType === 'SummaryTotalPriceDetailsBlock';
	},

	isListItemBlock(content: FieldsContent['content']): content is ListItemBlock {
		return content.contentType === 'ListItemBlock';
	},

	isPackageDetailsBlock(content: FieldsContent['content']): content is PackageDetailsBlock {
		return content.contentType === 'PackageDetailsBlock';
	},
};
